module.exports = __webpack_public_path__ + "img/a.a04e01c0.svg";